import { ArrayUtil } from "./ArrayUtil";
/**
 * Dictionary.ts
 *
 * Custom implementation of a non-iterative Map where Keys and Values are related by indexes in separate arrays.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map}
 */
export class Dictionary {
    constructor() {
        this.clear();
    }
    clear() {
        this.keys = [];
        this.values = [];
    }
    containsKey(key) {
        return this.keyIndex(key) >= 0;
    }
    setValue(key, value) {
        let index = this.keyIndex(key);
        index < 0
            ? this.addElement(key, value)
            : this.updateElement(index, value);
    }
    getValue(key) {
        let index = this.keyIndex(key);
        return index >= 0 ? this.values[index] : null;
    }
    remove(key) {
        this.removeElement(key);
    }
    size() {
        return this.keys.length;
    }
    getKeys() {
        return this.keys;
    }
    getValues() {
        return this.values;
    }
    equals(other) {
        return (ArrayUtil.elemEquals(this.getKeys(), other.getKeys()) &&
            ArrayUtil.elemEquals(this.getValues(), other.getValues()));
    }
    forEach(callback) {
        for (let i = 0; i < this.keys.length; i++) {
            callback(this.keys[i], this.values[i]);
        }
    }
    keyIndex(key) {
        return this.keys.indexOf(key);
    }
    addElement(key, value) {
        this.keys.push(key);
        this.values.push(value);
    }
    removeElement(key) {
        let index = this.keys.indexOf(key);
        if (index >= 0) {
            this.keys.splice(index, 1);
            this.values.splice(index, 1);
        }
    }
    updateElement(index, value) {
        this.values[index] = value;
    }
}
//# sourceMappingURL=Dictionary.js.map